{
  "required": "This field is required",
  "invalid": "This field is invalid",
  "firstNameRequired": "First name is required",
  "lastNameRequired": "Last name is required",
  "emailRequired": "Email is required",
  "emailInvalid": "Email is invalid",
  "passwordRequired": "Password is required",
  "passwordsMustMatch": "Passwords must match",
  "phoneRequired": "Phone number is required",
  "phoneInvalid": "Phone number is invalid",
  "licencePlateRequired": "Licence plate is required",
  "vehicleRequired": "Car is required",
  "acceptTermsOfUseRequired": "You must accept to continue",
  "minimumMustBeLessThanMaximum": "Minimum must be lower than maximum",
  "promoCodeMinCostMustBeHigherThanPromoCodeValue": "Promo code minimum cost must be higher than promo code value",
  "minNumber": "Value must be greater or equal to {{min}}",
  "maxNumber": "Value must be lower or equal to {{max}}",
  "invalidNumber": "Value must be a number"
}
